module.exports = __webpack_public_path__ + "img/14.7647896c.jpg";